<template>
  <v-container class="container-card">
    <v-card>
      <TabelaEmpresas />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaEmpresa",

  components: {
    TabelaEmpresas: () => import("@/components/empresa/empresas/TabelaEmpresas")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Empresa");
  }
};
</script>
